var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card" }, [
    _c("div", { staticClass: "card-header" }, [_vm._v(" Actualités ")]),
    _c("div", { staticClass: "card-container" }, [
      !_vm.gotActualites
        ? _c("div", [_vm._m(0)])
        : _vm.actualites.length
        ? _c("div", [
            _c(
              "div",
              {
                staticClass:
                  "card card-minimal table-scroll height-responsive-bottom-50"
              },
              [
                _c("div", { staticClass: "table-body" }, [
                  _c("table", { staticClass: "table table-sm" }, [
                    _vm._m(1),
                    _c(
                      "tbody",
                      _vm._l(_vm.actualites, function(actualite, i) {
                        return _c("tr", { key: i }, [
                          _c("td", { staticClass: "p-3" }, [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: actualite.lien,
                                  target: "_blank"
                                }
                              },
                              [
                                _c("img", {
                                  staticStyle: { width: "110px" },
                                  attrs: { src: actualite.image }
                                })
                              ]
                            )
                          ]),
                          _c("td", [
                            _c(
                              "a",
                              {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value: {
                                      content: actualite.description,
                                      placement: "bottom"
                                    },
                                    expression:
                                      "{content: actualite.description, placement: 'bottom'}"
                                  }
                                ],
                                attrs: {
                                  href: actualite.lien,
                                  target: "_blank"
                                }
                              },
                              [
                                _c("b", { staticClass: "text-dark" }, [
                                  _vm._v(_vm._s(actualite.titre))
                                ])
                              ]
                            )
                          ])
                        ])
                      }),
                      0
                    )
                  ])
                ])
              ]
            )
          ])
        : _c("div", [
            _c("span", { staticStyle: { "font-size": "12px" } }, [
              _vm._v("Echec de la requête")
            ])
          ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "card card-minimal table-scroll height-responsive-bottom-50"
      },
      [
        _c("div", { staticClass: "table-body" }, [
          _c(
            "div",
            { staticStyle: { "text-align": "center", "margin-top": "50px" } },
            [
              _c("img", {
                staticStyle: { height: "100px", "margin-left": "-8px" },
                attrs: {
                  alt: "en attente",
                  src: "/assets/images/spinners/cooking-blue-court.gif"
                }
              })
            ]
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [_c("col", { attrs: { width: "110px" } }), _c("col")])
  }
]
render._withStripped = true

export { render, staticRenderFns }